import "./App.css";
import SignupPage from "./component/User/Singup";
import Navbar from "./component/User/Navbar";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./component/LandingpPage/Home";
import Signup from "./component/Admin/Signup";
import { Toaster } from "react-hot-toast";
import Sidebar from "./component/Dashboard/Sidebar";
import ToolsUI from "./component/LandingpPage/SubComponent/Tools";
import BlogDetails from './component/LandingpPage/SubComponent/BlogDetails'
import PrivateRoute from "./PrivateRoute";
import MainPage from "./component/Blogs/MainPage";
import Hero from "./component/Blogs/CategoryIndividual/Hero";
import PrivacyPolicy from "./component/LandingpPage/SubComponent/PrivacyPolicySection";
import { useEffect } from "react";
import ConsulteaseWidget from "./component/ConsulteaseWidget";

function App() {
  useEffect(() => {
    const disableRightClick = (e) => {
      e.preventDefault();
      // toast.error("Right click is disabled for security reason");
    };
    const disableInspect = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key)) ||
        (e.ctrlKey && e.key === "U")
      ) {
        e.preventDefault();
        // toast.error("Inspection is disabled for security reason");
      }
    };

    document.addEventListener("contextmenu", disableRightClick);
    document.addEventListener("keydown", disableInspect);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableInspect);
    };
  }, []);


  return (
    <>

      <Toaster />
      <Router>
        <ConsulteaseWidget />
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/blog" element={<MainPage />} ></Route>
          <Route path="/login" element={<SignupPage />}></Route>
          <Route path="/adminlogin" element={<Signup />}></Route>
          <Route
            path="/dashboard"
            element={<PrivateRoute element={<Sidebar />} />}
          />
          <Route path="/tools" element={<ToolsUI />}></Route>
          <Route path="/blog/:id" element={<BlogDetails />}></Route>
          <Route path="/blogcategory/:category" element={<Hero />}></Route>
          <Route path="/privacypolicy" element={<PrivacyPolicy />}></Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
